import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchField } from '@/components/ui/SearchField';
import { TOURNAMENT_LIST_SEARCH_ENABLED } from '@/constants';
import styles from './styles.module.scss';

export interface TournamentsFilterBarProps {
  query: string;
  onQueryChange: (value: string) => void;
  /** Filters under the search (e.g. `TournamentStatusFilter`). */
  children?: React.ReactNode;
  /** Unique per mounted instance — builds `data-testid`s. */
  idPrefix: string;
}

/**
 * Tournament list toolbar: search field plus the list's filters — under it on
 * phones, in one row from tablet up. The search renders only while
 * `TOURNAMENT_LIST_SEARCH_ENABLED` is on.
 */
export const TournamentsFilterBar: React.FC<TournamentsFilterBarProps> = ({
  query,
  onQueryChange,
  children,
  idPrefix,
}) => {
  const { t } = useTranslation('tournament');

  return (
    <div className={styles.bar}>
      {TOURNAMENT_LIST_SEARCH_ENABLED && (
        <SearchField
          value={query}
          onChange={onQueryChange}
          placeholder={t('tournament:list.searchPlaceholder')}
          className={styles.search}
          testId={`${idPrefix}-search`}
        />
      )}
      {children}
    </div>
  );
};

export default TournamentsFilterBar;
